export const baseURL = 'https://neko-back.herokuapp.com/2.0'
